import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError("البريد الإلكتروني أو كلمة المرور غير صحيحة");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #0B5FA5, #29ABE2)", fontFamily: "'Noto Sans Arabic', sans-serif", direction: "rtl", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "48px 40px", width: "100%", maxWidth: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 72, height: 72, borderRadius: 20, background: "linear-gradient(135deg, #0B5FA5, #29ABE2)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 36, color: "#fff" }}>☩</div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: "#0B3D5C", margin: 0 }}>تماجيد جديدة</h1>
          <p style={{ fontSize: 14, color: "#5E8299", marginTop: 4 }}>لوحة تحكم المشرف</p>
        </div>

        <form onSubmit={handleSubmit}>
          {error && (
            <div style={{ background: "#FEF2F2", color: "#DC2626", padding: "10px 16px", borderRadius: 10, marginBottom: 16, fontSize: 14, textAlign: "center" }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#5E8299", marginBottom: 6, display: "block" }}>البريد الإلكتروني</label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              placeholder="admin@tamajeed.app"
              style={{ width: "100%", padding: "12px 16px", borderRadius: 12, border: "1.5px solid #CBE2F0", background: "#F0F7FC", fontSize: 15, fontFamily: "'Outfit', sans-serif", outline: "none", direction: "ltr", boxSizing: "border-box" }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#5E8299", marginBottom: 6, display: "block" }}>كلمة المرور</label>
            <input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              placeholder="••••••••"
              style={{ width: "100%", padding: "12px 16px", borderRadius: 12, border: "1.5px solid #CBE2F0", background: "#F0F7FC", fontSize: 15, fontFamily: "'Outfit', sans-serif", outline: "none", direction: "ltr", boxSizing: "border-box" }}
            />
          </div>

          <button
            type="submit" disabled={loading}
            style={{ width: "100%", padding: 14, borderRadius: 14, background: loading ? "#CBE2F0" : "linear-gradient(135deg, #0B5FA5, #29ABE2)", color: "#fff", border: "none", fontSize: 16, fontWeight: 700, cursor: loading ? "wait" : "pointer", fontFamily: "'Noto Sans Arabic', sans-serif" }}
          >
            {loading ? "جاري تسجيل الدخول..." : "تسجيل الدخول"}
          </button>
        </form>
      </div>
    </div>
  );
}
